import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import { useTranslation } from 'next-i18next';
import classes from './AccountSettingsCard.qmee.module.scss';

export type Props = {
  href: string;
  notificationCount?: number;
  className?: string;
};

export default function AccountSettingsCard({ href, notificationCount = 0, className }: Props) {
  const { t } = useTranslation();

  return (
    <Card isLink className={clsx(classes.root, className)}>
      <A href={href} className={classes.innerLink}>
        <Txt className={classes.title}>Account Settings</Txt>
        {notificationCount > 0 && (
          <span
            className={classes.badge}
            aria-label={t('{{ count }} notifications', { count: notificationCount })}
          >
            {notificationCount}
          </span>
        )}
      </A>
    </Card>
  );
}
